module.exports = __webpack_public_path__ + "8287e6b1.svg";